import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11M5.993 9.159c1.19-.317 3.276-.649 5.57-.578 2.3.071 4.71.545 6.627 1.748a1 1 0 0 0 1.063-1.695c-2.333-1.463-5.138-1.975-7.628-2.052-2.498-.077-4.778.28-6.146.644a1 1 0 1 0 .514 1.933m5.036 3.41c-1.887-.066-3.55.23-4.469.508a1 1 0 0 1-.58-1.914c1.127-.341 3.01-.667 5.12-.592 2.112.075 4.527.554 6.648 1.899a1 1 0 1 1-1.07 1.69c-1.728-1.096-3.762-1.523-5.649-1.59Zm-4.17 4.102c.92-.23 2.508-.461 4.187-.38 1.694.082 3.346.476 4.524 1.37a1 1 0 0 0 1.21-1.593c-1.64-1.244-3.76-1.684-5.638-1.775-1.893-.091-3.677.165-4.768.438a1 1 0 1 0 .485 1.94",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandMusicSpotify = { render };
export {
  brandMusicSpotify as default,
  render
};
//# sourceMappingURL=brand-music-spotify.svg.js.map
